export class ResolveLogEntryDto {
    narrative: string;

    static fromNarrative(narrative: string) : ResolveLogEntryDto {
        const dto = new ResolveLogEntryDto();
        dto.narrative = narrative;

        return dto;
    }
}